export default {
    dwellTimesMapInfo: [],
    lineVelocityMapInfo: [],
    apiCallsInProgress: 0
}